// extracted by mini-css-extract-plugin
export default {"heading":"cookies_heading__I1KsN","desc":"cookies_desc__zh3gO","btnContainer":"cookies_btnContainer__Aj6N8","mainContainer":"cookies_mainContainer__iAnsJ"};